export default "__VITE_ASSET__CbavzysZ__"